const secrets = {
    third_party_token_set: {
        token_not_found: 'Record del token non trovato.',
        access_token_expired: 'Il token di accesso è scaduto. Per favore riconnetti il tuo account.',
    },
};
export default Object.freeze(secrets);
